import utils from "../../utils";
import fetch from "../fetch";

const DataGrid = {
    selections: [],
    refresh: function () {

    }
}

/**
 * @method onSelect
 * @param {array} ids [id: int, ...]
 * @return {promise}
 */
const onSelect = (ids) => {
    DataGrid.selections = ids;
}

/**
 * @method setRefresh
 * @param {function} callback
 * @return {promise}
 */
const setRefresh = (callback) => {
    DataGrid.refresh = callback;
};

const getSelection = () => {
    return DataGrid.selections;
}

const prefixUrl = 'teacher/teaching/quality/schoolSupervisor';

const columns = utils.columns([
    {
        key: '$index',
        label: '序号',
        width: 75
    },
    {
        key: 'weekNum',
        label: '周次',
    },
    {
        key: 'week',
        label: '星期',
    },
    {
        key: 'courseNum',
        label: '听课节次',
    },
    {
        key: 'employeeCode',
        label: '教师工号',
    },
    {
        key: 'employeeName',
        label: '教师姓名',
    },
    {
        key: 'orgName',
        label: '所属部门',
    },
    {
        key: 'courseName',
        label: '课程名称',
    },
    {
        key: 'className',
        label: '班级名称',
    },
    {
        key: 'address',
        label: '上课地址',
    },
    {
        key: 'appraiserCode',
        label: '评价人工号',
    },
    {
        key: 'appraiserName',
        label: '评价人姓名',
    },
    {
        key: 'result',
        label: '校督导最终评价结果',
    },
    {
        key: 'evalProject',
        label: '测评项目'
    },
    {
        key: 'termName',
        label: '所属学期',
    },
])

const querySearch = (keywords = {pageNum: 1, pageSize: 100}) => {
    return fetch.post(`${prefixUrl}/query?pageNum=${keywords.pageNum}&pageSize=${keywords.pageSize}&order=${keywords.order || ''}&sort=${keywords.sort || ''}`,keywords)
    .then(res =>{
        const data = res.payload.data;
            return Object.assign({
                result: data.dataList,
                selects: data.dataList.map(e => {
                    return {
                        value: e.id,
                        checked: false,
                    }
                }),
                checked: false,
                total: data.total,
                pageIndex: data.pageNum,
                pageSize: data.pageSize,
                notify: ([]).length ? '' : '暂无数据...'
            })
    })
}

const remove = (ids) => {
    return fetch.post(`${prefixUrl}/delete`,ids)
    .then(res => {
        if ( res.code === 200 ) {
            return res;
        }
    })
}

const queryByEmployeeName = (params) => {
    return fetch.get(`employee/query/by/employeeName?employeeName=${params.employeeName || ''}&limit=${params.limit || undefined}`)
    .then(res => {
        if ( res.code === 200 ) {
            return res.payload.data;
        }
    })
}

const queryByClassName = (params) => {
    return fetch.get(`classes/query/by/className?className=${params.className || ''}&limit=${params.limit || undefined}`)
    .then(res => {
        if ( res.code === 200 ) {
            return res.payload.data;
        }
    })
}

const queryByCourseName = (params) => {
    return fetch.get(`course/query/by/courseName?courseName=${params.courseName || ''}&limit=${params.limit || undefined}`)
    .then(res => {
        if ( res.code === 200 ) {
            return res.payload.data
        }
    })
}

const getDataById = (id) => {
    return fetch.get(`${prefixUrl}/get/${id}`)
    .then(res => {
        if ( res.code === 200 ) {
            return res.payload.data;
        }
    })
}

const update = (keywords) => {
    return fetch.post(`${prefixUrl}/update`,keywords)
    .then(res => {
        if ( res.code === 200 ) {
            DataGrid.selections = [];
            DataGrid.refresh();
            return res;
        }
    })
}

export default{
    update,
    getDataById,
    queryByClassName,
    queryByCourseName,
    queryByEmployeeName,
    remove,
    querySearch,
    columns,
    onSelect,
    setRefresh,
    getSelection,
}
